import React from 'react';

import { FlexBox } from 'ml-rubiks-styleguide/src/box';
import { Button } from 'ml-rubiks-styleguide/src/button';
import { IconFileDownload } from 'ml-rubiks-styleguide/src/icon';

import { useI18n } from '../../contexts/i18n-context';

interface MandateDownloadButtonProps {
    mandateUrl: string;
    onComplete: () => void;
}

export const MandateDownloadButton: React.FC<MandateDownloadButtonProps> = ({
    mandateUrl,
    onComplete
}) => {
    const { t } = useI18n();

    const handleClick = () => {
        window.open(mandateUrl, '_blank', 'noopener,noreferrer');
        onComplete();
    };

    return (
        <FlexBox stack gap={2} py={2}>
            <Button
                variant="contained"
                color="primary"
                size="large"
                fullWidth
                onClick={handleClick}
                startIcon={<IconFileDownload color="inherit" />}
            >
                {t('payment.ach.mandate.download', 'Download Mandate')}
            </Button>
        </FlexBox>
    );
};
